import * as types from './actionTypes';
import { getCustomer, putCustomer } from '../api/customerApi';

export function loadCustomerSuccess(customer) {
  return { type: types.LOAD_CUSTOMER_SUCCESS, customer };
}

export function updateCustomerSuccess(customer) {
  return { type: types.UPDATE_CUSTOMER_SUCCESS, customer };
}

export function loadCustomer(customer) {
  return async function(dispatch) {
    const { data } = await getCustomer(customer);
    dispatch(loadCustomerSuccess(data));
  };
}

export function updateCustomer(customer) {
  return async function(dispatch) {
    const { data } = await putCustomer(customer);
    dispatch(updateCustomerSuccess(data));
  };
}



// WEBPACK FOOTER //
// ./src/actions/customerActions.js